import React, { FC, useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';
import { useFieldArray, useFormContext } from 'react-hook-form';
import NoSsr from '@common/noSsr';
import { ReactSelectInputStyles } from '@components/profile/profileOverlay/overlays/ReactSelectStyles';
import useExaminations from '@components/profile/profileOverlay/overlays/skill/query/useExaminations';
import ScoreGradeContents from '@components/profile/profileOverlay/overlays/skill/skillWrite/examinationsForm/ScoreGradeContents';
import ExaminationChipList from '@components/profile/profileOverlay/overlays/skill/skillWrite/examinationsForm/ExaminationChipList';

import styles from '../../skill.module.scss';
import { ExaminationVO } from '@domain/vo/profile/ProfileSkillVO';
import { ExaminationDto } from '@domain/rs/profile/skill/ExaminationRs';
import { LoadOptions } from '@domain/constant/ReactSelectOption';
import useDebounce from '@utils/hooks/useDebounce';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface IExaminationsFormProps {
  visible: boolean;
}

const ExaminationsForm: FC<IExaminationsFormProps> = ({ visible }) => {
  const {
    control,
    formState: { isSubmitted },
  } = useFormContext();
  const fieldName = 'examinations';
  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldName,
  });

  const { mutateAsync: examinationsMutateAsync } = useExaminations();

  const [selectedExam, setSelectedExam] = useState<ExaminationDto | null>(null);

  const onInit = () => {
    setSelectedExam(null);
  };

  const onSelectExam = (selected: any) => {
    setSelectedExam(selected as ExaminationDto);
  };

  const loadExaminationOptions = useDebounce((keyword: string, callback: LoadOptions) => {
    examinationsMutateAsync(keyword).then((examinations: ExaminationDto[]) => {
      //선택된 항목 option에서 제거
      const selectedList = fields.map((selected: any) => selected.code);
      callback(examinations.filter((item) => !selectedList.includes(item.code)));
    });
  }, 100);

  const onAppendExam = (selected: ExaminationVO) => {
    append(selected);

    setSelectedExam(null);
  };

  useEffect(() => {
    if (!visible || isSubmitted) onInit();
  }, [visible, isSubmitted]);

  return (
    <div className={cx('languageExamArea', { hidden: !visible })}>
      <em className={cx('sectionTitle')}>공인 어학시험</em>

      <div className={cx('selectArea')}>
        <div className={cx('selectInner')}>
          <NoSsr>
            <AsyncSelect
              className={cx('select')}
              placeholder={'공인 어학시험을 검색해주세요.'}
              loadOptions={loadExaminationOptions}
              getOptionValue={(option) => option.code}
              getOptionLabel={(option) => option.name}
              openMenuOnClick={false}
              styles={ReactSelectInputStyles}
              isClearable={true}
              onChange={onSelectExam}
              value={selectedExam}
            />
          </NoSsr>
        </div>

        {/* [D] 시험에 따라 점수 / 수준으로 구분됨. 확인 필요합니다. */}
        <div className={cx('selectInner')}>
          <ScoreGradeContents examination={selectedExam} onAppend={onAppendExam} />
        </div>
      </div>

      {/* 선택한 아이템 영역 */}
      <ExaminationChipList
        prefixName={fieldName}
        examinationChips={fields as unknown as ExaminationVO[]}
        onDelete={(idx: number) => remove(idx)}
      />
    </div>
  );
};

export default ExaminationsForm;
